import React, { useEffect, useRef, useState } from "react";
import RadioFilters from "./RadioFilters";
import SearchBar from "./SearchBar";
import { IsValidSearchInput, getParamFromCriteria } from "../services/searchService";
import { getVehicleAndCustomerInfo } from "../services/vehicleService";
import VehicleDataGrid from "./serviceHistoryComponents/VehicleDataGrid";
import useStore from "../hooks/useStore";

const SearchVehicleInspection = (props) => {
  const {
    onChangeLicenseFound,
    onShowMessage,
    onLoading,
    vehicleData,
    nextBestAction,
    setShowList,
    showList,
    searchedValue,
    setSearchedValue,
    comesFromNBA,
    criteriaSelected,
    setcriteriaSelected,
  } = props;

  const inputRef = useRef();
  const { storeId } = useStore();

  useEffect(()=>{
    inputRef.current.value = searchedValue[0] 
    setcriteriaSelected(searchedValue[1])
    
    if (!comesFromNBA) {
      onClear()
    }
  },[comesFromNBA])

  const isResponseValid = (vehicleDataList) => {
    if (vehicleDataList.length === 0 || vehicleDataList.isInvalid) {
      onLoading(false);
      inputRef.current.value = "";
      const message = vehicleDataList.isInvalid ? vehicleDataList.description : "No Vehicle Information found for given values."
      onShowMessage(message, "warning");
      return false;
    }
    return true;
  };

  const onChangeCriteria = (newCriteria) => {
    setShowList(false)
    setcriteriaSelected(newCriteria);
  };

  const onSearch = async (event) => {
    const inputValue = inputRef.current.value;
    
    if (event.key == 'Enter' && criteriaSelected == -1 ) {
      onShowMessage("You must select a search criteria before searching.", "info");
      return;
    }

    if (!IsValidSearchInput(inputValue, criteriaSelected)) {
      inputRef.current.value = "";
      onShowMessage("Invalid input. Please try again.", "error");
      return;
    }

    try {
      setSearchedValue([inputValue, criteriaSelected])
      onLoading(true);
      const value = getParamFromCriteria({inputValue, criteriaSelected});
      const vehicleDataList = await getVehicleAndCustomerInfo(value, storeId);
      if (!isResponseValid(vehicleDataList)) {
        return;
      }
      onChangeLicenseFound(vehicleDataList);
      setShowList(true)
      localStorage.setItem('SHorderBy', JSON.stringify([{field: 'storeId', sort: "asc"}]));
      onLoading(false);
    } catch (error) {
      onLoading(false);
      console.log("Error: ", error);
      onShowMessage(
        "There has been a problem searching. Please try again later.",
        "error"
      );
    }
  };

  const onClear = async () => {
    inputRef.current.value = ""
    setcriteriaSelected(-1)
    setShowList(false)
    localStorage.setItem('SHorderBy', JSON.stringify([{field: 'storeId', sort: "asc"}]));
  }

  return (
    <>
      <div className={"search-layout"}>
        <div>
          SEARCH
          <SearchBar onSearch={onSearch}  onSearchChange={(e) => {
              setSearchedValue(e);
            }}
            inputRef={inputRef} />
          <RadioFilters
            filters={[
              { name: "LICENSE PLATE", disable: false}, 
              { name: "PHONE", disable: false},
              { name: "EMAIL", disable: false},
              { name: "CUSTOMER NAME", disable: false},
              { name: "WORK ORDER", disable: false },
              { name: "INVOICE", disable: false }
          ]}
            onChangeCriteria={onChangeCriteria}
            criteriaSelected={criteriaSelected}
          />
        </div>
        <div className="search-buttons">
          <button id="searchBtn" onClick={onSearch} disabled={criteriaSelected === -1}>
            Search
          </button>
          <button id="clearBtn" onClick={onClear} disabled={criteriaSelected === -1}>
            Clear
          </button>
        </div>
      </div>
      {showList ? 
        <VehicleDataGrid
          vehicleData={vehicleData}
          nextBestAction={nextBestAction}
          rowsPerPage = {5}
          criteriaSelected={criteriaSelected}
          sx= {{"& .MuiDataGrid-row:hover": {backgroundColor: "transparent"}}}
        /> : null
    }
  </>
      
  );
};

export default React.forwardRef(SearchVehicleInspection);
